import { render, staticRenderFns } from "./NoticeBoard.vue?vue&type=template&id=2036593f&scoped=true&"
import script from "./NoticeBoard.vue?vue&type=script&lang=js&"
export * from "./NoticeBoard.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBoard.vue?vue&type=style&index=0&id=2036593f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036593f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
